import React, { useEffect } from 'react'
import DatePicker, { ReactDatePickerProps, registerLocale } from 'react-datepicker'
import { enUS } from 'date-fns/locale'
import { formatDateStripTime } from 'utils/date'

export type DatePickerProps = ReactDatePickerProps & DatePickerFormatProps

export const ReactDatePicker: React.FC<DatePickerProps> = (props) => {
  useEffect(() => {
    registerLocale('en-US', enUS)
  }, [])

  return (
    <DatePicker
      wrapperClassName={props.wrapperClassName}
      popperClassName={props.popperClassName}
      locale={'en-US'}
      {...props}
      dateFormat={getDatePickerFormat(props)}
    />
  )
}

export interface DatePickerFormatProps {
  dateFormat?: string
  showOnlyDate?: boolean
}

const getDatePickerFormat = (props: DatePickerFormatProps) => {
  const { dateFormat: dateTimeFormat, showOnlyDate } = props

  if (showOnlyDate && dateTimeFormat) {
    return formatDateStripTime(dateTimeFormat)
  }

  return dateTimeFormat
}
